module.exports = __webpack_public_path__ + "static/img/logo07.b7c603ff.png";